import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton, Typography } from '@mui/material';
import { FC } from 'react';

import { OrderItem } from 'types/pos.interface';

import {
  CardBatchDetailBox,
  CardItemsWrapper,
  CardProductContainer,
  CardProductsHeaderBar,
  CardProductsHeaderBox,
  CardProductsWrapper,
} from '../OrderProductsList/index.styled';

interface OrderProductRowProps {
  products: OrderItem[];
}

const OrderProductRow: FC<OrderProductRowProps> = ({ products }: OrderProductRowProps) => {
  const title = products[0].item;
  const count = products.length;
  const total = products.reduce((acc, product) => acc + product.price, 0);

  return (
    <CardProductsWrapper>
      <CardProductsHeaderBar>
        <CardProductsHeaderBox>
          <Typography fontWeight="bold" marginRight={1}>
            {title}
          </Typography>
          <Typography variant="body2">{`${count} item(s)`}</Typography>
        </CardProductsHeaderBox>

        <CardProductsHeaderBox>
          <Typography variant="body2" fontWeight="bold">{`Total: $${total}`}</Typography>
        </CardProductsHeaderBox>
      </CardProductsHeaderBar>

      <CardItemsWrapper>
        {products.map((product, index) => (
          <CardProductContainer key={index}>
            <Box display="flex" gap={1}>
              <IconButton size="small" id={`button-deleteCardItem-${index}`}>
                <DeleteOutlineIcon />
              </IconButton>

              <IconButton size="small" id={`button-aboutCardItem-${index}`}>
                <AttachMoneyIcon />
              </IconButton>

              <CardBatchDetailBox>
                <Typography variant="body2">{`Batch: ${product.batch ?? ''}`}</Typography>
                <Typography variant="body2">{`Brand: ${product.brand ?? ''}`}</Typography>
                <Typography variant="body2">{`Quantity: ${product.quantity ?? ''}`}</Typography>
              </CardBatchDetailBox>
            </Box>

            <Typography>{`$${product.price}`}</Typography>
          </CardProductContainer>
        ))}
      </CardItemsWrapper>
    </CardProductsWrapper>
  );
};

export default OrderProductRow;
